// Journal d'erreurs navigateur + fetch JSON avec nouvelles tentatives
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let sent = 0;

export const logClientError = (data) => {
  if (sent >= 10) return;
  sent += 1;
  const body = JSON.stringify({ kind: 'error', url: window.location.href, user_agent: navigator.userAgent, ...data });
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(`${BACKEND_URL}/api/client-log`, new Blob([body], { type: 'application/json' }))) return;
  } catch (e) { /* repli sur fetch */ }
  try { fetch(`${BACKEND_URL}/api/client-log`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {}); } catch (e) { /* ignoré */ }
};

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export const fetchJsonRetry = async (path, retries = 3) => {
  let lastError;
  for (let attempt = 1; attempt <= retries; attempt += 1) {
    let status = null;
    try {
      const res = await fetch(`${BACKEND_URL}${path}`, { cache: 'no-store' });
      status = res.status;
      const text = await res.text();
      if (!res.ok) throw new Error(`HTTP ${res.status} ${text.slice(0, 150)}`);
      try { return JSON.parse(text); } catch (e) { throw new Error(`Réponse non JSON : ${text.slice(0, 150)}`); }
    } catch (e) {
      lastError = e;
      logClientError({ kind: 'fetch_failed', endpoint: path, status, message: String(e?.message || e), attempt });
      if (attempt < retries) await wait(600 * attempt);
    }
  }
  throw lastError;
};

export const installGlobalErrorLog = () => {
  window.addEventListener('error', (e) => logClientError({ kind: 'js_error', message: `${e.message || ''} @ ${e.filename || ''}:${e.lineno || ''}` }));
  window.addEventListener('unhandledrejection', (e) => logClientError({ kind: 'promise_rejection', message: String(e.reason?.message || e.reason || '') }));
};
